<template>
  <v-alert type="error" v-if="msg" class="alert">
    {{msg}}
  </v-alert>
</template>

<script>
export default {
  name: 'fin-error-msg',
  props: {
    msg: {
      type: String
    }
  }
}
</script>

<style scoped>

  ::v-deep .v-alert {
    padding: 0;
  }

  ::v-deep .v-alert__content {
    color: #000;
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 19px;
    letter-spacing: normal;
  }

  ::v-deep .v-alert__icon.v-icon {
    color: red
  }

  .v-application .error {
    background-color: white !important;
    padding: 0;
  }

</style>
